module.exports = __webpack_public_path__ + "6cd13dbd150ac0c7f337a2939a3d50a8.woff";